export default {
    namespaced: true,
    state: {
      payCid:"",
    },
    mutations: {
     editPayCid(state,val){
         state.payCid = val
     }
    },
  };
  